import React from 'react';
import { Link } from 'react-router-dom';
import { Dumbbell, Phone, MapPin, Mail } from 'lucide-react';
import { GYM_INFO } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-[#39FF14]/20">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <Dumbbell className="w-8 h-8 text-[#39FF14]" />
              <span className="text-2xl font-bold text-white uppercase">
                Iron <span className="text-[#39FF14]">Crust</span>
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              {GYM_INFO.tagline}
            </p>
            <p className="text-gray-500 text-xs">
              Building champions in {GYM_INFO.location}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4 uppercase">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#39FF14] transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/personal-training" className="text-gray-400 hover:text-[#39FF14] transition-colors text-sm">
                  Personal Training
                </Link>
              </li>
              <li>
                <Link to="/strength-programs" className="text-gray-400 hover:text-[#39FF14] transition-colors text-sm">
                  Strength Programs
                </Link>
              </li>
              <li>
                <Link to="/supplements" className="text-gray-400 hover:text-[#39FF14] transition-colors text-sm">
                  Supplements
                </Link>
              </li>
              <li>
                <Link to="/memberships" className="text-gray-400 hover:text-[#39FF14] transition-colors text-sm">
                  Memberships
                </Link>
              </li>
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4 uppercase">Programs</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/fat-loss" className="text-gray-400 hover:text-[#39FF14] transition-colors text-sm">
                  Fat Loss Programs
                </Link>
              </li>
              <li>
                <Link to="/strength-programs" className="text-gray-400 hover:text-[#39FF14] transition-colors text-sm">
                  Powerlifting
                </Link>
              </li>
              <li>
                <Link to="/strength-programs" className="text-gray-400 hover:text-[#39FF14] transition-colors text-sm">
                  Hypertrophy Training
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-gray-400 hover:text-[#39FF14] transition-colors text-sm">
                  Success Stories
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#39FF14] transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4 uppercase">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#39FF14] flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">{GYM_INFO.location}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#39FF14] flex-shrink-0" />
                <a
                  href={`tel:${GYM_INFO.whatsapp}`}
                  className="text-gray-400 hover:text-[#39FF14] transition-colors text-sm"
                >
                  {GYM_INFO.whatsapp}
                </a>
              </li>
              <li>
                <a
                  href={`${GYM_INFO.whatsappLink}?text=Hi, I'm interested in Iron Crust Gym!`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 mt-2 px-4 py-2 bg-[#39FF14] text-black font-bold text-sm uppercase rounded-full hover:scale-105 transition-transform"
                >
                  WhatsApp Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {currentYear} {GYM_INFO.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <span className="text-gray-500 text-xs">FSSAI Certified</span>
              <span className="text-gray-500 text-xs">Lab Tested Supplements</span>
              <span className="text-gray-500 text-xs">500+ Transformations</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
